module.exports = __webpack_public_path__ + "img/icon_lock.7f1a4d3d.png";